import { motion } from 'framer-motion'
import { ArrowLeft } from 'lucide-react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { GestorDashboardTaskDetailContent } from '@/components/Gestores/GestorDashboardTaskDetailContent'
import { Button } from '@/components/ui/Button'
import { useGestorDashboardTaskDetailPage } from '@/hooks/useGestorDashboardTaskDetailPage'

export default function GestorDashboardTaskDetailPage() {
  const { detail, loading, error, goBack } = useGestorDashboardTaskDetailPage()

  return (
    <DashboardLayout
      title={detail?.title ?? 'Tarefa eKyte'}
      actions={
        <Button variant='secondary' size='sm' type='button' onClick={goBack}>
          <ArrowLeft size={14} />
          Voltar ao dashboard
        </Button>
      }
    >
      {error && (
        <div className='mb-4 rounded-lg border border-warning/20 bg-warning/10 px-4 py-3 text-sm text-warning'>
          {error}
        </div>
      )}

      {loading ? (
        <div className='glass-card flex justify-center py-16'>
          <div className='h-8 w-8 animate-spin rounded-full border-2 border-accent border-t-transparent' />
        </div>
      ) : detail ? (
        <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}>
          <GestorDashboardTaskDetailContent detail={detail} />
        </motion.div>
      ) : null}
    </DashboardLayout>
  )
}
